export default {
  check_drawings_Legend: 'Legend',
  check_drawings_list: 'check drawing list',
  detail: 'detail',
  return_to_check_list: 'return to check list',
  check_drawings_suggestions: 'suggestions',
  booth_report_info: 'booth report drawing info',
  modify: 'modify',
  cancel: 'cancel',
  booth_info: 'Booth info',
  status: 'status',
  expo_name: 'expo name',
  exhibitor: 'exhibitor',
  boothNo: 'boothNo',
  "保险验证码": "保险验证码",
  booth_area: 'booth area',
  top_structure_coverage_area: 'top structure coverage area',
  booth_size: 'booth size(Length×width)',
  largest_size_across_the_structure: 'largest size across the structure',
  total_power_consumption_of_the_booth: 'total power consumption of the booth',
  power_line_specifications: 'power line specifications',
  minimum_thickness_of_loadBearing_wall: 'minimum thickness of loadBearing wall',
  highest_point_to_the_ground_vertical_height: 'highest point to the ground vertical height',
  producer_info: 'Producer info',
  taxCode: 'taxcode',
  construction_unit: 'builder unit',
  builder_manager: "builder manager",
  construction_manager: 'construction manager',
  contact_way: 'contact way',
  email: 'email',
  fax: 'fax',
  check_imgs: 'Check images',
  click_for_larger_image: 'click for larger image',
  construction_personnel_registration_info: 'Construction personnel registration info',
  name: 'name',
  sex: 'sex',
  idcard: 'idcard',
  phone: 'phone',
  remark: 'remark',
  car_info: 'Car information',
  number: 'number',
  car_type: 'car type',
  number_plate: 'number plate',
  car_license_mailing_payment_info: 'Car license mailing payment information',
  recipient: 'recipient',
  postal_number: 'postal number',
  address: 'address',
  female: 'female',
  male: 'male',
  external_vehicle: 'external vehicle',
  local_vehicle: 'local vehicle',
  '值守电工姓名': 'Electrician on duty',
  '值守电工联系电话': 'On-duty electrician contact telephone',
  '序号': 'No.',
  '报图资料': 'Map information',
  '报图类别': 'Report type',
  '审核状态': 'Audit status',
  '审核时间': 'Audit time',
  '展开查看审图详情': 'Expand to view drawing review details',
  '实际施工单位': 'Actual construction unit',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsDetail.js